import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Eye, Download, Package } from "react-feather";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";

const AllCustomerAdmin = () => {
  const [customers, setCustomers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filters
  const [search, setSearch] = useState("");
  const [countryFilter, setCountryFilter] = useState("All");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllUsers`);
        if (response.data.message === "Users fetched successfully.") {
          setCustomers(response.data.users);
          setFilteredData(response.data.users);
        }
      } catch (error) {
        console.error("Error fetching user data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    let filtered = [...customers];

    if (search) {
      filtered = filtered.filter((user) =>
        `${user.first_name} ${user.middle_name || ""} ${user.last_name} ${user.user_email} ${user.phone}`
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }

    if (countryFilter !== "All") {
      filtered = filtered.filter((user) => user.country?.toLowerCase() === countryFilter.toLowerCase());
    }

    if (startDate && endDate) {
      filtered = filtered.filter((user) => {
        const created = new Date(user.created_at);
        return created >= startDate && created <= endDate;
      });
    }

    setFilteredData(filtered);
    setCurrentPage(1); // Reset to page 1 on filter change
  }, [search, countryFilter, startDate, endDate, customers]);

  const handleDownloadExcel = () => {
    const dataToExport = filteredData.map((user) => ({
      "User Name": `${user.first_name} ${user.middle_name || ""} ${user.last_name}`,
      Email: user.user_email,
      Phone: user.phone || "-",
      Country: user.country || "-",
      "Created At": new Date(user.created_at).toLocaleString(),
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "All Customers");
    XLSX.writeFile(wb, "all_customers.xlsx");
  };

  const countries = [...new Set(customers.map((u) => u.country).filter(Boolean))];

  // Pagination logic
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
            <h4>All Customers</h4>
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search name/email/phone"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <select
                  className="form-control"
                  value={countryFilter}
                  onChange={(e) => setCountryFilter(e.target.value)}
                >
                  <option value="All">All Countries</option>
                  {countries.map((country, idx) => (
                    <option key={idx} value={country}>
                      {country}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  placeholderText="Start Date"
                  className="form-control"
                />
              </div>
              <div className="col-md-2">
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  placeholderText="End Date"
                  className="form-control"
                />
              </div>
              <div className="col-md-2">
                <select
                  className="form-control"
                  value={recordsPerPage}
                  onChange={(e) => setRecordsPerPage(parseInt(e.target.value))}
                >
                  <option value="10">10 per page</option>
                  <option value="25">25 per page</option>
                  <option value="50">50 per page</option>
                  <option value="100">100 per page</option>
                </select>
              </div>
              <div className="col-md-1">
                <span className="btn btn-success w-100" onClick={handleDownloadExcel}>
                  <Download size={17} />
                </span>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body p-0">
              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" />
                </div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table className="custom-table">
                    <thead className=" ">
                      <tr>
                        <th>#</th>
                        <th>User Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Country</th>
                        <th>Created At</th>
                        <th>Order History</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRecords.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No users found.
                          </td>
                        </tr>
                      ) : (
                        currentRecords.map((user, index) => (
                          <tr key={user.id}>
                            <td>{indexOfFirstRecord + index + 1}</td>
                            <td>{`${user.first_name} ${user.middle_name || ""} ${user.last_name}`}</td>
                            <td>{user.user_email}</td>
                            <td>{user.phone || "-"}</td>
                            <td>{user.country || "-"}</td>
                            <td>{new Date(user.created_at).toLocaleString()}</td>
                            <td>
                              <Link to={`/admin/customer-order/${user.id}`} className="btn btn-primary btn-sm">
                                <Package size={16} /> Orders
                              </Link>
                            </td>
                            <td>
                              <Link to={`/admin/customer-detail/${user.user_unique_id}`} className="btn btn-info btn-sm">
                                <Eye size={16} /> View
                              </Link>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>

                  {/* Pagination */}
                  <nav>
                    <ul className="pagination justify-content-end px-3">
                      {Array.from({ length: totalPages }, (_, i) => (
                        <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                          <button className="page-link" onClick={() => paginate(i + 1)}>
                            {i + 1}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllCustomerAdmin;
